import { lazy } from 'react';

export const FileShowPageLazy = lazy(() => import('./FileShowPage'));
